var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Widget, WidgetGroup } from '@easyquery/core';
/**
 * The widget responsed for rendering process bar.
 */
var ProcessWidget = /** @class */ (function (_super) {
    __extends(ProcessWidget, _super);
    /**
     * The default constructor.
     * @param slot The html element.
     */
    function ProcessWidget(slot) {
        var _this = _super.call(this, slot) || this;
        _this.element = slot;
        _this.element.style.display = 'none';
        _this.group = WidgetGroup.All;
        return _this;
    }
    ProcessWidget.prototype.getWidgetType = function () {
        return 'processIndicator';
    };
    /**
     * On process start implementation
     */
    ProcessWidget.prototype.onProcessStartCore = function () {
        this.element.style.display = '';
    };
    /**
    * On process end implementation
    */
    ProcessWidget.prototype.onProcessEndCore = function () {
        this.element.style.display = 'none';
    };
    return ProcessWidget;
}(Widget));
export { ProcessWidget };
//# sourceMappingURL=process_widget.js.map